export var ClientStatus;
(function (ClientStatus) {
    ClientStatus["Active"] = "Active";
    ClientStatus["Inactive"] = "Inactive";
    ClientStatus["Prospective"] = "Prospective";
})(ClientStatus || (ClientStatus = {}));
export var MatterType;
(function (MatterType) {
    MatterType["MergersAndAcquisitions"] = "MergersAndAcquisitions";
    MatterType["CorporateRestructuring"] = "CorporateRestructuring";
    MatterType["IPLicensing"] = "IPLicensing";
    MatterType["SecuritiesOffering"] = "SecuritiesOffering";
    MatterType["JointVenture"] = "JointVenture";
    MatterType["DueDiligence"] = "DueDiligence";
})(MatterType || (MatterType = {}));
export var MatterStatus;
(function (MatterStatus) {
    MatterStatus["Active"] = "Active";
    MatterStatus["Closed"] = "Closed";
    MatterStatus["OnHold"] = "OnHold";
    MatterStatus["PendingReview"] = "PendingReview";
})(MatterStatus || (MatterStatus = {}));
//# sourceMappingURL=client.js.map